import { BaseViewStore, HyperlinkCellData } from 'core/stores';
import { action, makeObservable } from 'mobx';
import { FulfillmentOrderStore } from 'modules/order/stores';
import _ from 'lodash';
import { isSome } from 'core/utils';

class FulfillmentOrderItemsExpandListViewStore extends BaseViewStore {
	noDataItem = true;

	constructor(rootStore, componentProps) {
		super(rootStore);
		makeObservable(this);
		this.store = new FulfillmentOrderStore(rootStore);
		this.initialize(componentProps.dataItem.id);
	}

	@action.bound
	initialize = async id => {
		this.suspend();
		await this.getFulfillmentOrder(id);
		this.getData();
		this.getTableData();
		this.resume();
	};

	getTableData = () => {
		this.tableData = {
			columns: [
				{
					key: 'name',
					title: 'FULFILLMENTORDERITEMSVIEW.NAME',
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				{
					key: 'sku',
					title: 'FULFILLMENTORDERITEMSVIEW.SKU',
					dataCell: HyperlinkCellData,
					onClick: dataItem => this.openProductDetailPage(dataItem.productId),
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				{
					key: 'quantity',
					title: 'FULFILLMENTORDERITEMSVIEW.QUANTITY',
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				...(this.data.some(item => isSome(item.parentSku))
					? [
							{
								key: 'parentSku',
								title: 'FULFILLMENTORDERITEMSVIEW.PARENTSKU',
								selected: true,
								width: 200,
								filter: null,
								resizable: false,
								sortable: false,
							},
					  ]
					: []),
			],
		};
	};

	getFulfillmentOrder = async id => {
		this.fulfillmentOrder = await this.store.getFulfillmentOrder(id, {
			embed: [
				'fulfillmentOrderItems',
				'fulfillmentOrderItems.product',
				'fulfillmentOrderItems.orderLine',
				'fulfillmentOrderItems.orderLine.product',
			],
		});
	};

	getData = () => {
		this.data = _.map(_.groupBy(this.fulfillmentOrder.fulfillmentOrderItems, 'productId'), group => {
			let totalQuantity = 0;
			_.forEach(group, item => (totalQuantity += item.quantity));
			return {
				productId: group[0].productId,
				sku: group[0].sku,
				quantity: totalQuantity,
				name: group[0].product.name,
				parentSku: group[0].orderLine.product.isMultiProduct ? group[0].orderLine.product.mainSku : null,
			};
		});
	};

	openProductDetailPage = id => {
		this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
			id: id,
		});
	};
}

export default FulfillmentOrderItemsExpandListViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/FulfillmentOrderItemsExpandListViewStore.js